import { css } from 'lit';

export const style = css`
  #share-address-toggle {
    margin-top: -1rem;
  }

  .step-address-v2-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  refi-heading {
    margin-bottom: -0.25em;
  }

  /* For mobile phones */
  [class*='next-button'] {
    margin-top: 0.5rem;
    width: 100%;
  }

  /* For Desktop */
  @media only screen and (width >= 744px) {
    .next-button {
      align-self: center;
      width: fit-content;
    }
  }

  .coborrower-card {
    background-color: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    width: 100%;
  }

  .coborrower-card-content {
    padding: 1rem;
  }
`;
